<template>
  <div class="row">
    <div class="col-xs-12" v-if="detalhes.dado.tipo !== 'T'">
      <h3>Gráfico</h3>
      <Chart
        v-if="detalhes.dado.periodicidade === 6"
        :css-classes="'chart-container'"
        :chart-data="dados_grafico"
        :coloredLine="true"
        :options="chartOptions"
      ></Chart>
      <bar-chart
        v-if="detalhes.dado.periodicidade === 1"
        ref="graph_barra"
        :css-classes="'chart-container'"
        :chart-data="dados_grafico"
        :gradiente="false"
        :options="chartOptions"
      ></bar-chart>
    </div>
  </div>
</template>

<script>
import { mesesAbr } from '@/utils'
import { LineChart2 as Chart, BarChart } from '../common'

export default {
  components: {
    Chart,
    BarChart
  },
  props: {
    detalhes: {
      type: Object,
      required: true
    },
    valores: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chartUrl: 'detalhes/valores/' + this.$route.params.id,
      meses: mesesAbr,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        elements: {
          point: {
            radius: 4,
            hoverRadius: 8
          }
        }
      }
    }
  },
  methods: {
    retornarGraficoMensal(base) {
      const year_base = this.retornarObjetoMensal()
      const anos = Object.keys(year_base)

      for (let index = 0; index < anos.length; index++) {
        const ano = anos[index]
        base.datasets.push({
          label: ano,
          data: year_base[ano]
        })
      }

      base.labels = this.meses
      this.chartOptions.legend.display = true

      return base
    },
    retornarGraficoAnual(base) {
      const dados = [...this.valores]
      base.datasets.push({
        label: 'Valores por ano',
        data: [],
        pointBackgroundColor: 'white',
        pointBorderWidth: 1,
        pointBorderColor: '#000',
        pointHoverBackgroundColor: '#FFF'
      })

      for (let index = 0; index < dados.length; index++) {
        let data = new Date(dados[index].data).getFullYear()
        base.labels.push(data)
        base.datasets[0].data.push(dados[index].valor)
      }

      return base
    }
  },
  computed: {
    dados_grafico() {
      let grafico = {
        labels: [],
        datasets: []
      }

      switch (this.detalhes.dado.periodicidade) {
        case 1:
          return this.retornarGraficoMensal(grafico)
        case 6:
          return this.retornarGraficoAnual(grafico)
        default:
          return grafico
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  max-height: 350px;
  min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dados/Graficos.vue